import { Grid, Stack, Typography } from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"
import { MultilangJob } from "src/services/api/document"
import { dateWithTime } from "src/utils/dateHelper"
import { ShowMoreButton } from "src/components/browser/buttons/ShowMoreButton"

export const BasicInfo = ({
  multilangJob,
  onShowMoreClick,
  showMoreOpened
}: {
  multilangJob: MultilangJob
  onShowMoreClick: () => void
  showMoreOpened?: boolean
}) => {
  const { t } = useTranslation("multilang")

  const DateInfo = ({ label, date }: { label: string; date?: string }) => (
    <Stack direction={"row"} justifyContent={"flex-start"} alignItems={"center"}>
      <Typography sx={{ marginRight: 2 }}>{label}</Typography>
      <Typography sx={{ fontWeight: "bold" }}>{date ? dateWithTime(date) : "-"}</Typography>
    </Stack>
  )

  const gridBorder = { borderColor: "divider" }
  const gridPadding = { p: 2 }

  return (
    <Grid container spacing={0}>
      <Grid item xs={6} sx={{ borderRight: 1, borderBottom: 1, ...gridBorder, ...gridPadding }}>
        <DateInfo label={t("uploaded")} date={multilangJob.uploadDate} />
      </Grid>
      <Grid item xs={6} sx={{ borderBottom: 1, ...gridBorder, ...gridPadding }}>
        {<DateInfo label={t("dueDate")} date={multilangJob.dueDate} />}
      </Grid>
      <Grid item xs={6} sx={{ borderRight: 1, ...gridBorder, ...gridPadding }}>
        {<DateInfo label={t("delivered")} date={multilangJob.deliveryDate} />}
      </Grid>
      <Grid item xs={6} sx={{ ...gridPadding, py: 1 }}>
        {showMoreOpened !== undefined && <ShowMoreButton opened={showMoreOpened} onShowMoreClick={onShowMoreClick} />}
      </Grid>
    </Grid>
  )
}
